import React, { useState } from "react";

function PardonForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    reason: "",
    document: null,
  });
  const [message, setMessage] = useState("");
  const [ocrText, setOcrText] = useState("");

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("Processing...");
    setOcrText("");

    // Create a FormData object to handle the multipart form request
    const data = new FormData();
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("reason", formData.reason);
    data.append("document", formData.document);

    try {
      const response = await fetch("https://pardoncms.erichayth.com/submit", {
        method: "POST",
        body: data,
      });

      const result = await response.json();
      if (result.ocrResult) {
        setOcrText(result.ocrResult);
        setMessage("Document processed successfully!");
      } else {
        setMessage("Error: No text was extracted from the document.");
      }
    } catch (error) {
      setMessage("Error: " + error.message);
    }
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '30px' }}>Pardon Request Form</h1>
      <form onSubmit={handleSubmit} style={{ marginBottom: '30px' }}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Name:</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Reason for Pardon:</label>
          <textarea
            name="reason"
            value={formData.reason}
            onChange={handleInputChange}
            required
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', minHeight: '100px' }}
          />
        </div>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Upload Document:</label>
          <input
            type="file"
            name="document"
            accept="application/pdf, image/png, image/jpeg"
            onChange={handleInputChange}
            required
            style={{ width: '100%', padding: '8px' }}
          />
        </div>
        <button 
          type="submit"
          style={{
            backgroundColor: '#007bff',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            width: '100%'
          }}
        >
          Submit
        </button>
      </form>
      
      {message && (
        <div style={{ 
          marginBottom: '20px',
          padding: '10px',
          borderRadius: '4px',
          backgroundColor: message.includes('Error') ? '#ffebee' : '#e8f5e9',
          color: message.includes('Error') ? '#c62828' : '#2e7d32'
        }}>
          {message}
        </div>
      )}
      
      {ocrText && (
        <div style={{ 
          marginTop: '30px',
          padding: '20px',
          backgroundColor: '#f5f5f5',
          borderRadius: '4px',
          whiteSpace: 'pre-wrap'
        }}>
          <h2 style={{ marginTop: '0', marginBottom: '15px' }}>Extracted Text:</h2>
          <div style={{ 
            fontFamily: 'monospace',
            lineHeight: '1.5'
          }}>
            {ocrText}
          </div>
        </div>
      )}
    </div>
  );
}

export default PardonForm;
